export const environment = {
  production: false,

  port: process.env.PORT,

  backendEndpoint: process.env.REACT_APP_BACK_END_ENDPOINT,
  graphQLEndpoint: process.env.REACT_APP_GRAPH_QL_ENDPOINT,
  loginEndpoint: process.env.REACT_APP_LOGIN_ENDPOINT,
  resetPasswordEndpoint: process.env.REACT_APP_RESET_PASSWORD_ENDPOINT,

  nodeEnv: process.env.NODE_ENV,
  mockedJWT: process.env.REACT_APP_MOCK_AUTHENTICATION,
  VATValue: parseFloat(process.env.REACT_APP_VAT_VALUE || '0.21'),

  automaticCalculationCron: {
    ACCOUNT_NAME: process.env.AUTOMATIC_CALCULATION_ACCOUNT_NAME,
    ACCOUNT_PASSWORD: process.env.AUTOMATIC_CALCULATION_ACCOUNT_PASSWORD,
  },
} as const;
